module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.54813375.woff2";